<template>
  <div class="preview">
    <div class="title">
      {{ $t('servers.streamPreview') }}
    </div>

    <StreamVideo v-if="hls_stream_url" :hls_stream_url="hls_stream_url" />

    <div
      class="streamArea d-flex align-items-center justify-content-center flex-column"
      v-else
    >
      <div>
        <div class="info">
          <i class="fas fa-spinner spinner-item"></i>
        </div>
        <div class="info-text">
          {{ $t('servers.streamInfo') }}
        </div>
        <div>
          <b-dropdown variant="primary" class="publishItems">
            <template #button-content>
              <i class="far fa-plus mr-2"> </i>
              {{ $t('servers.addNewPublishLink') }}
            </template>

            <b-dropdown-item
              class="d-flex justify-content-center"
              @click="addNewSteam('twitch')"
            >
              <i class="fab fa-twitch environmentIcon twitch"> </i>
              <span class="environment">Twitch</span>
            </b-dropdown-item>

            <b-dropdown-item
              class="d-flex justify-content-center"
              @click="addNewSteam('youtube')"
            >
              <i class="fab fa-youtube environmentIcon youtube"> </i>
              <span class="environment">Youtube</span>
            </b-dropdown-item>

            <b-dropdown-item
              class="d-flex justify-content-center"
              @click="addNewSteam('facebook')"
            >
              <i class="fab fa-facebook environmentIcon facebook"> </i>
              <span class="environment">Facebook</span>
            </b-dropdown-item>

            <b-dropdown-item
              class="d-flex justify-content-center"
              @click="addNewSteam('twitter')"
            >
              <i class="fab fa-twitter environmentIcon twitter"> </i>
              <span class="environment">Twitter</span>
            </b-dropdown-item>

            <b-dropdown-item
              class="d-flex justify-content-center"
              @click="addNewSteam('steam')"
            >
              <i class="fab fa-steam environmentIcon steam"> </i>
              <span class="environment">Steam</span>
            </b-dropdown-item>

            <b-dropdown-item
              class="d-flex justify-content-center"
              @click="addNewSteam('custom')"
            >
              <i class="fas fa-link environmentIcon"> </i>
              <span class="environment">Custom</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['hls_stream_url'],
  name: 'StreamPreview',
  methods: {
    addNewSteam(type) {
      this.$emit('addNewSteam', type)
    },
  },
  components: {
    StreamVideo: () => import('@/components/stream/StreamVideo'),
  },
}
</script>

<style lang="scss" scoped>
.preview {
  border-radius: 12px;
  background: #fff;

  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #4a4b68;
    padding: 20px 20px;
  }
  .streamArea {
    margin-top: 0px;
    margin-bottom: 20px;
    min-height: 335px;
    background: rgba(238, 229, 255, 0.4);
    border-radius: 12px;
    // border-top-left-radius: 0px;
    // border-top-right-radius: 0px;
    div {
      width: 300px;
      text-align: center;
      margin-bottom: 20px;
    }
    .info {
      .spinner-item {
        font-size: 34px;
        line-height: 34px;
        color: #464e5f;
        animation: spin 1.5s linear infinite;
      }
    }
    .info-text {
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 19px;
      text-align: center;
      color: #464e5f;
    }
    img {
      width: 100%;
    }
  }
}
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
